<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h3>Telefone e Mídias Sociais</h3>
        <Contatos
          v-model="concedente.contatos"
          ref="contatos"
          class="border rounded-lg p-3 mb-3"
        />
      </b-col>
      <b-col cols="12">
        <h3>Endereço</h3>
        <block-checkbox
          v-model="concedente.sem_endereco"
          title="Sem endereço"
          description="O concedente não possui endereço físico disponível"
          class="mb-3"
        />
        <Endereco
          v-model="concedente.endereco"
          ref="endereco"
          v-if="!concedente.sem_endereco"
          :numero_required="false"
          class="border rounded-lg p-3"
        />
        <div v-else>
          <h5 class="text-center p-4">Sem endereço</h5>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { useConcedenteForm } from "../../composables/useConcedenteForm";
import BlockCheckbox from "@/components/Inputs/BlockCheckbox.vue";

export default defineComponent({
  components: { Endereco, Contatos, BlockCheckbox },
  setup() {
    const {
      concedente,
      isValid: validate,
      hasErrors,
    } = useConcedenteForm(["endereco", "contatos"]);
    const endereco = ref(null);
    const contatos = ref(null);

    function isValid() {
      endereco.value?.$v?.$touch();
      contatos.value?.$v?.$touch();

      return validate();
    }

    return { concedente, endereco, contatos, isValid, hasErrors };
  },
});
</script>

<style lang="scss">
.input-sem-endereco {
  .custom-control-label {
    padding-right: 2em;
    font-size: 0.8em !important;

    &::before,
    &::after {
      left: inherit;
      right: 0px;
    }
  }
}
</style>
